import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-sanction-grid',
  templateUrl: './loan-sanction-grid.component.html',
  styleUrls: ['./loan-sanction-grid.component.css']
})
export class LoanSanctionGridComponent implements OnInit {
  title="LoanSanctionList"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/loan-sanction-grid/loan-sanction-grid.component.ts